import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { Typeahead } from 'react-bootstrap-typeahead'
import DatePicker from 'react-bootstrap-date-picker'
import {
  Button,
  Col,
  Panel,
  Form,
  FormControl,
  FormGroup,
  Modal,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'

import Dropdown from '../dropdown'
import Validators from '../../utils/validators'

@observer(['activities', 'partners', 'tasks', 'users', 'globals'])

export default class PartnerTasks extends Component {
  constructor(props) {
    super(props)

    let partnerId = this.props.partnerId
    let showEditModal = false;

    this.props.partners.loadPartnerTasks(partnerId)
    this.props.users.loadAllOrganizationUsers(localStorage.getItem('userOrganizationId'))
    this.props.tasks.loadtaskPriorities()
    this.props.tasks.loadTaskStates()

    if (this.props.taskId > 0) {
      showEditModal = true
      this.openEdit(this.props.taskId)
    }

    this.state = {
      showDetailsModal: false,
      partnerPhone: '',
      partnerEmail: '',
      taskPriorityId: 1,
      newTask: '',
      dueDate: '',
      editTaskPriorityId: 1,
      editTaskStateId: 1,
      editTask: '',
      editDueDate: '',
      assignedUserId: 0,
      assignedUserName: '',
      editAssignedUserId: 0,
      editAssignedUserName: '',
      editNewAssigned: 0,
      ogAssignedUserId: 0,
      showEditModal
    }
  }

  validateForm() {
    if (this.getNewPartnerTaskAssignedUserValidationState() == 'error') {
      return false
    }
    if (this.getNewPartnerTaskDueDateValidationState() == 'error') {
      return false
    }

    if (this.getNewPartnerTaskNewTaskValidationState() == 'error') {
      return false
    }

    return true
  }

  validateEditForm() {
    if (this.getEditPartnerTaskAssignedUserValidationState() == 'error') {
      return false
    }

    if (this.getEditPartnerTaskDueDateValidationState() == 'error') {
      return false
    }

    if (this.getEditPartnerEditTaskValidationState() == 'error') {
      return false
    }

    return true
  }

  getNewPartnerTaskAssignedUserValidationState() {
    if (this.state && Validators.validString(this.state.assignedUserId)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditPartnerTaskAssignedUserValidationState() {
    if (this.state && Validators.validString(this.state.editAssignedUserId)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewPartnerTaskDueDateValidationState() {
    if (Validators.validString(this.state.dueDate)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditPartnerTaskDueDateValidationState() {
    if (Validators.validString(this.state.editDueDate)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewPartnerTaskNewTaskValidationState() {
    if (Validators.validString(this.state.newTask)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditPartnerEditTaskValidationState() {
    if (Validators.validString(this.state.editTask)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  newPartnerTaskDueDateChanged(e) {
    let dateString = ''
    if (e) {
      let dd = new Date(e)
      dateString = dd.getUTCFullYear() + '-' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2)
    }

    this.setState({
      dueDate: dateString
    })
  }

  editPartnerTaskDueDateChanged(e) {
    let editDateString = ''
    if (e) {
      let dd = new Date(e)
      editDateString = dd.getUTCFullYear() + '-' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2)
    }

    this.setState({
      editDueDate: editDateString
    })
  }

  newPartnerTaskNewTaskChanged(e) {
    this.setState({
      newTask: e.target.value
    })
  }

  editPartnerTaskTaskChanged(e) {
    this.setState({
      editTask: e.target.value
    })
  }

  onTaskPriorityChanged(e) {
    this.setState({
      taskPriorityId: e.target.value
    })
  }

  onEditTaskPriorityChanged(e) {
    this.setState({
      editTaskPriorityId: e.target.value
    })
  }

  onEditTaskStateChanged(e) {
    this.setState({
      editTaskStateId: e.target.value
    })
  }

  onAssignedUserChanged(e) {
    if (e.length > 0) {
      this.setState({
        assignedUserId: e[0].id,
        assignedUserName: e[0].name
      })
    } else {
      this.setState({
        assignedUserId: 0,
        assignedUserName: ''
      })
    }
  }

  onEditAssignedUserChanged(e) {
    if (e.length > 0) {
      if (this.state.ogAssignedUserId != e[0].id) {
        this.setState({
          editNewAssigned: 1
        })
      } else {
        this.setState({
          editNewAssigned: 0
        })
      }
    } else {
        this.setState({
          editNewAssigned: 0
        })
    }

    if (e.length > 0) {
      this.setState({
        editAssignedUserId: e[0].id,
        editAssignedUserName: e[0].name
      })
    } else {
      this.setState({
        editAssignedUserId: 0,
        editAssignedUserName: ''
      })
    }
  }

  openEdit(id) {
    if (this.state) {
      this.setState({
        showEditModal: true
      })
    }

    this.props.partners.loadPartnerTask(id, (data) => {
      let dd = new Date(data.dueDate)
      let editDateString = dd.getUTCFullYear() + '-' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2)

      this.setState({
        partnerPhone: data.partner.phone,
        partnerEmail: data.partner.email,
        editTaskId: id,
        editTaskPriorityId: data.taskPriorityId,
        editTaskStateId: data.taskStateId,
        editDueDate: editDateString,
        editTask: data.task,
        editAssignedUserId: data.assignedUserId,
        ogAssignedUserId: data.assignedUserId,
        editAssignedUserName: data.assignedUserName,
        showEditModal: true
      })
    })
  }

  open() {
    this.setState({
      showDetailsModal: true
    })
  }

  closeEdit() {
    this.setState({
      showEditModal: false,
      partnerPhone: '',
      partnerEmail: '',
      editAssignedUserId: 0,
      editAssignedUserName: '',
      editNewAssigned: 0,
      ogAssignedUserId: 0
    })
  }

  close() {
    this.setState({
      showDetailsModal: false,
      dueDate: '',
      newTask: '',
    })
  }

  newPartnerTask(e) {
    if (this.validateForm()) {
      this.props.partners.addPartnerTask({
        partnerId: this.props.partnerId,
        userId: this.props.globals.loggedInUser.id,
        assignedUserId: this.state.assignedUserId,
        newAssigned: 1,
        taskPriorityId: this.state.taskPriorityId,
        //dueDate: document.getElementById('dueDate').getAttribute('data-formattedvalue'),
        dueDate: this.state.dueDate,
        task: this.state.newTask
      }, (data) => {
        //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        this.props.activities.logNewActivity(localStorage.getItem('userId'), 'create', 9, data.addPartnerTask.id, 2, this.props.partnerId)
      })

      this.setState({
        taskPriorityId: 1,
        dueDate: '',
        newTask: ''
      })

      this.close()
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  sortByCreatedDate(a, b, order) {
    const aa = a.formattedCreatedDate.split('-')
    const bb = b.formattedCreatedDate.split('-')

    return this.sortByDate(aa, bb, order)
  }

  sortByDueDate(a, b, order) {
    const aa = a.formattedDueDate.split('-')
    const bb = b.formattedDueDate.split('-')

    return this.sortByDate(aa, bb, order)
  }

  sortByDate(aa, bb, order) {
    const fa = aa[2] + aa[0] + aa[1]
    const fb = bb[2] + bb[0] + bb[1]

    if (order == 'desc') {
      return fb - fa
    } else {
      return fa - fb
    }
  }

  updatePartnerTask(row, cellName, cellValue) {

    let taskPriorityId = 1
    let taskStateId = 1

    for( let i=0; i<this.props.tasks.data.length; i++ ) {
      if (this.props.tasks.data[i].name == row.priority) {
        taskPriorityId = this.props.tasks.data[i].id
        break
      }
    }

    for( let i=0; i<this.props.tasks.taskStates.length; i++ ) {
      if (this.props.tasks.taskStates[i].name == row.state) {
        taskStateId = this.props.tasks.taskStates[i].id
        break
      }
    }

    this.props.tasks.updatePartnerTask({
      id: row.id,
      task: row.task,
      taskPriorityId,
      taskStateId
    })
  }

  savePartnerTask() {
    if (this.validateEditForm()) {
      this.props.partners.updatePartnerTask({
        id: this.state.editTaskId,
        partnerId: this.props.partnerId,
        assignedUserId: this.state.editAssignedUserId,
        newAssigned: this.state.editNewAssigned,
        taskPriorityId: this.state.editTaskPriorityId,
        taskStateId: this.state.editTaskStateId,
        dueDate: this.state.editDueDate,
        task: this.state.editTask
      })

      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'update', 9, this.state.editTaskId, 2, this.props.partnerId)

      this.closeEdit()
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  deletePartnerTask(id) {
    if (confirm("Are you sure you want to delete this task?")) {
      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'delete', 9, id, 2, this.props.partnerId)

      this.props.tasks.deletePartnerTask(id)
      this.props.partners.loadPartnerTasks(this.props.partnerId)
    }
  }

  formatActions(cell, row) {
    return (
      <div>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'editPartnerTask-' + cell}>Set As Default</Tooltip> }><Button bsSize="small" bsStyle="warning" onClick={ (e) => { this.openEdit(cell) } }><i className="fa fa-pencil" aria-hidden="true"></i></Button></OverlayTrigger>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'deletePartnerTask-' + cell}>Set As Default</Tooltip> }><Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deletePartnerTask(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button></OverlayTrigger>
      </div>
    )
  }

  render() {

    const taskStateOptions = this.props.tasks.taskStates.map((state) => {
      return state.name
    })

    const taskPrioritiesOptions = this.props.tasks.data.map((priority) => {
      return priority.name
    })

    const options = {
      onAddRow: this.newPartnerTask.bind(this),
      defaultSortName: 'formattedDueDate',  // default sort column name
      defaultSortOrder: 'asc'  // default sort order
    }

    /*
    const taskStateDropdown = (
      <FormControl componentClass="select" id="editTaskStateId">
      {
        this.props.tasks.taskStates.map((state) => {
          return <option value={ state.id }>{ state.name }</option>
        })
      }
      </FormControl>
    )


    const taskPrioritiesDropdown = (
      <FormControl componentClass="select" placeholder={ this.props.tasks.data.name } defaultValue={ this.props.tasks.data.id } id="taskPriorityId">
        {
          this.props.tasks.data.map((priority) => {
            return <option value={ priority.id }>{ priority.name }</option>
          })
        }
      </FormControl>
    )


    const editTaskPrioritiesDropdown = (
      <FormControl componentClass="select" placeholder={ this.props.tasks.data.name } id="editTaskPriorityId">
        {
          this.props.tasks.data.map((priority) => {
            return <option value={ priority.id }>{ priority.name }</option>
          })
        }
      </FormControl>
    )
    */

    const tasksTable = (
      <div>
        <Button bsSize="small" bsStyle="info" onClick={this.open.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> New</Button>
        <BootstrapTable
            data={ this.props.partners.tasks }
            striped={ true }
            hover={ true }
            pagination={ true }
            search={ true }
            options={ options }
            bordered={ false }>
            <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="formattedCreatedDate" sortFunc={ this.sortByCreatedDate.bind(this) } dataSort={ true } editable={ false }>Created Date</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="formattedDueDate" sortFunc={ this.sortByDueDate.bind(this) } dataSort={ true } editable={ false }>Due Date</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="userFullName" dataSort={ true } editable={ false }>Created By</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="assignedUserName" dataSort={ true } editable={ false }>Assigned To</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="priority" dataSort={ true } editable={{ validator: Validators.validString, type: 'select', options: { values: taskPrioritiesOptions } }}>Priority</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="state" dataSort={ true } editable={{ validator: Validators.validString, type: 'select', options: { values: taskStateOptions } }}>State</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="task" dataSort={ true } editable={{ validator: Validators.validString }}>Task</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )

    return (
      <div>
        <div>
          { /* <Collapsible title="Tasks" content={ tasksTable } /> */ }
          { tasksTable }
        </div>
        <div style={{ clear: 'both' }}></div>
        <Modal show={ this.state.showDetailsModal } onHide={ this.close.bind(this) } bsSize="medium">
          <Modal.Header closeButton>
            <Modal.Title>New Task</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="newTaskForm">
              <FormGroup validationState={ this.getNewPartnerTaskAssignedUserValidationState() } >
                <Col><Typeahead clearButton labelKey="name" options={ this.props.users.all } onChange={ this.onAssignedUserChanged.bind(this) } placeholder="Choose a user..." /></Col>
              </FormGroup>
              <FormGroup>
                { /* <Col sm={ 6 }>{ taskPrioritiesDropdown }</Col> */ }
                <Col sm={ 6 }>
                  <FormGroup>
                    <Dropdown data={ this.props.tasks.data } id="taskPriorityId" onChange={ this.onTaskPriorityChanged.bind(this) } />
                  </FormGroup>
                </Col>
                <Col sm={ 6 }>
                  <FormGroup validationState={ this.getNewPartnerTaskDueDateValidationState() } >
                    <DatePicker id="dueDate" dateFormat="YYYY-MM-DD" value={ this.state.dueDate } onChange={ this.newPartnerTaskDueDateChanged.bind(this) } />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup validationState={ this.getNewPartnerTaskNewTaskValidationState() } >
                <Col sm={ 12 }><FormControl componentClass="textarea" placeholder="Task" id="newTask" onChange={ this.newPartnerTaskNewTaskChanged.bind(this) } /></Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.close.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.newPartnerTask.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={ this.state.showEditModal } onHide={ this.closeEdit.bind(this) } bsSize="medium">
          <Modal.Header closeButton>
            <Modal.Title>Edit Task</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="editTaskForm">
              <Panel header={ <h3>Contact Information</h3> }>
                <Col sm={ 4 }>Phone: { this.state.partnerPhone }</Col>
                <Col sm={ 6 }>Email: { this.state.partnerEmail }</Col>
              </Panel>
              <Panel header={ <h3>Task Information</h3> }>
                <FormGroup validationState={ this.getEditPartnerTaskAssignedUserValidationState() } >
                  <input type="hidden" id="editTaskId" />
                  <Col><Typeahead clearButton labelKey="name" options={ this.props.users.all } onChange={ this.onEditAssignedUserChanged.bind(this) } selected={ [{ id: this.state.editAssignedUserId, name: this.state.editAssignedUserName }] } placeholder="Choose a user..." /></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={ 4 }><Dropdown data={ this.props.tasks.data } id="editTaskPriorityId" defaultValue={ this.state.editTaskPriorityId } onChange={ this.onEditTaskPriorityChanged.bind(this) } /></Col>
                  <Col sm={ 4 }><Dropdown data={ this.props.tasks.taskStates } id="editTaskStateId" defaultValue={ this.state.editTaskStateId }onChange={ this.onEditTaskStateChanged.bind(this) } /></Col>
                  <Col sm={ 4 }>
                    <FormGroup validationState={ this.getEditPartnerTaskDueDateValidationState() } >
                      <DatePicker id="editDueDate" dateFormat="YYYY-MM-DD" value={ this.state.editDueDate } value={ this.state.editDueDate } onChange={ this.editPartnerTaskDueDateChanged.bind(this) } />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup validationState={ this.getEditPartnerEditTaskValidationState() } >
                  <Col sm={ 12 }><FormControl componentClass="textarea" placeholder="Task" id="editTask" value={ this.state.editTask } onChange={ this.editPartnerTaskTaskChanged.bind(this) } /></Col>
                </FormGroup>
                </Panel>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeEdit.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.savePartnerTask.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partner/partnertasks.js